import Layout from '@/layout/index.vue';

export default [
  {
    path: '/testData',
    component: Layout,
    name: 'testData',
    redirect: '/testData/server1/retire_info_1',
    meta: { title: '测试平台', icon: 'el-icon-s-unfold' },
    children: [
      {
        path: 'server1',
        component: () => import('@/views/appManage/layout.vue'), // 这里是子菜单的布局组件
        name: 'server1',
        meta: {
          title: '直配11',
          icon: 'el-icon-s-unfold',
          alwaysShow: true, // 关键：即使只有一个子路由，也要显示
        },
        children: [
          {
            path: 'retire_info_1',
            name: 'retireInfo1',
            component: () => import('@/views/appManage/retire_info.vue'),
            meta: { title: '收货', icon: 'el-icon-box' },
          },
          {
            path: 'retire_info_2',
            name: 'retireInfo2',
            component: () => import('@/views/appManage/retire_info.vue'),
            meta: { title: '位置巡检', icon: 'el-icon-location' },
          },
          {
            path: 'retire_info_3',
            name: 'retireInfo3',
            component: () => import('@/views/appManage/retire_info.vue'),
            meta: { title: '随工', icon: 'el-icon-user' },
          },
          {
            path: 'retire_info_4',
            name: 'retireInfo4',
            component: () => import('@/views/appManage/retire_info.vue'),
            meta: { title: '位置确认', icon: 'el-icon-check' },
          },
        ],
      },
    ],
  },
];
